import { useRef } from 'react';
import { motion, useInView, useReducedMotion } from 'framer-motion';

function ScrollReveal({ children, delay = 0, direction = 'up', className = '' }) {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: '-80px 0px' });
  const shouldReduceMotion = useReducedMotion();

  const offset = direction === 'left' ? { x: -40, y: 0 } : { x: 0, y: 30 };
  const hidden = shouldReduceMotion ? { opacity: 0 } : { opacity: 0, ...offset };
  const shown = shouldReduceMotion
    ? { opacity: 1 }
    : { opacity: 1, x: 0, y: 0, transition: { duration: 0.85, ease: 'easeOut', delay } };

  return (
    <motion.div ref={ref} initial={hidden} animate={isInView ? shown : hidden} className={className}>
      {children}
    </motion.div>
  );
}

export default ScrollReveal;
